import React, { useState } from 'react';
import UrlForm from './components/UrlForm';
import ResultsDisplay from './components/ResultsDisplay';
import { Container, Box, Typography, Card, CardContent, Divider, Grid } from '@mui/material';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

function App() {
  
  const [formData, setFormData] = useState({
    urlDestino: '',
    utmCampaign: '',
    utmId: '',
    utmSource: '',
    utmMedium: '',
    utmTerm: '', 
    utmContent: '', 
  });

  const [results, setResults] = useState({
    fullUrl: '',
    shortUrl: '',
    show: false,
  });

  const handleFormSubmit = async (e) => { // função assincrona para que possa usar o await para esperar resposta da API
    e.preventDefault();

    // Montar a URL
    let url = formData.urlDestino;
    const params = [];

    if (formData.utmSource) {
      params.push(`utm_source=${formData.utmSource}`);
    }
    if (formData.utmMedium) {
      params.push(`utm_medium=${formData.utmMedium}`);
    }
    if(formData.utmCampaign){
      params.push(`utm_campaign=${formData.utmCampaign}`);
    }
    if (formData.utmId) {
        params.push(`utm_id=${formData.utmId}`);
    }

    if(params.length > 0){
     url += '?' + params.join('&');
    }

    // Encurtamento da URL

    let shortUrl = '';
    try{
      const response =  await fetch(`https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`);
      if(response.ok) {
        shortUrl = await response.text();
      }else{
        console.error('Erro ao encurtar a URL:', response.statusText);
      }
    }catch (error){
      console.error('Erro na chamada da API de encurtamento:', error);
    }

    // Atualiza o estado com a URL completa e mostra os resultados
    setResults({
      ...results,
      fullUrl: url,
      shortUrl: shortUrl,
      show: true,
    });
  };
  return (
    <>
    <ToastContainer autoClose={5000} />
    <Box
      sx={{
        minHeight: '100vh',
        //background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
        py: 2,
        backgroundColor: '#e2e2e2',
      }}
    >
      <Container maxWidth="lg">
        <Card
          sx={{
            //borderRadius: 4,
            //boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
            overflow: 'hidden',            
          }}
        >
          <CardContent sx={{ p: 4 }}>
            {/* Cabeçalho */}
            <Typography
              variant="h3"
              component="h1"
              gutterBottom
              align="center"
              sx={{ 
                fontWeight: 700, 
                color: '#fff',
                backgroundColor: '#333',
                py: 2,
                borderRadius: 2,
              }}
            >
              URL Manager
            </Typography>
           
          
            {/* Layout em duas colunas */}
            <Grid container spacing={4}>
              {/* Coluna esquerda: Formulário */}
              <Grid item xs={12} md={6}>
                <UrlForm
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                />
              </Grid>

              {/* Coluna direita: Resultados */}
              <Grid item xs={12} md={6}>
                {results.show ? (
                  <ResultsDisplay results={results} />
                ) : (
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'text.disabled',
                      border: '2px dashed #ccc',
                      borderRadius: 3,
                      p: 3,
                      textAlign: 'center',
                    }}
                  >
                    <Typography variant="body1">
                      Preencha o formulário e os resultados aparecerão aqui.
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Box>
    </>
  );
}

export default App;
